import React, { forwardRef } from "react";
import { useSpring, config, animated } from "@react-spring/web";
import { Container } from "./styled-components";

export interface AnimatedContainerProps {
  isVisible: boolean;
  children: React.ReactNode;
}

const AnimatedContainer = animated(Container);

const AnimatedSelectionsContainer = forwardRef<
  HTMLDivElement,
  AnimatedContainerProps
>(({ isVisible, children }, ref) => {
  const styles = useSpring({
    opacity: isVisible ? 1 : 0,
    transform: isVisible
      ? "translate3d(0px, 0px, 0px)"
      : "translate3d(0px, -13px, 0px)",
    config: isVisible ? config.stiff : { duration: 300 }
  });

  return (
    <AnimatedContainer
      ref={ref}
      style={styles}
      data-qa-label="bet-slip-selection-container"
    >
      {children}
    </AnimatedContainer>
  );
});

export default AnimatedSelectionsContainer;
